import { Box, type BoxProps } from '@mui/material'

export const FullPageWrapper = (props: BoxProps) => {
  return <Box display={'flex'} flexDirection={'column'} height={'100%'} {...props} />
}
